const AusCasefileIntakeDrawerScope = {
  DRAWER: 'aus-casefile-intake',
};

export const AusCasefileIntakeDrawerTestIds = {
  DRAWER_CONTAINER: `${AusCasefileIntakeDrawerScope.DRAWER}.container`,
  DRAWER_FORM: `${AusCasefileIntakeDrawerScope.DRAWER}.form`,
  DU_CASEFILE_FIELD: `${AusCasefileIntakeDrawerScope.DRAWER}.du-casefile-field`,
  LP_AUS_KEY_FIELD: `${AusCasefileIntakeDrawerScope.DRAWER}.lp-aus-key-field`,
  SUBMIT_BUTTON: `${AusCasefileIntakeDrawerScope.DRAWER}.submit-button`,
};
